import './scripts/jquery';

import 'slick-carousel';
import 'flexibility';
import 'photoswipe/dist/photoswipe';
import 'photoswipe/dist/photoswipe-ui-default';
import 'bootstrap-select';
import 'director';
import 'domurl';
import 'urijs';
import 'jquery.reel';
import 'bootstrap-datepicker';
import 'cookies-eu-banner';
import 'bootstrap-slider';

// Bootstrap JS modules (if you use them individually)
import 'bootstrap-sass/assets/javascripts/bootstrap/affix';
import 'bootstrap-sass/assets/javascripts/bootstrap/alert';
import 'bootstrap-sass/assets/javascripts/bootstrap/dropdown';
import 'bootstrap-sass/assets/javascripts/bootstrap/tooltip';
import 'bootstrap-sass/assets/javascripts/bootstrap/modal';
import 'bootstrap-sass/assets/javascripts/bootstrap/transition';
import 'bootstrap-sass/assets/javascripts/bootstrap/button';
import 'bootstrap-sass/assets/javascripts/bootstrap/popover';
import 'bootstrap-sass/assets/javascripts/bootstrap/carousel';
import 'bootstrap-sass/assets/javascripts/bootstrap/scrollspy';
import 'bootstrap-sass/assets/javascripts/bootstrap/collapse';
import 'bootstrap-sass/assets/javascripts/bootstrap/tab';

import "animate.css/animate.css";
import "photoswipe/dist/photoswipe.css";
import "bootstrap-select/dist/css/bootstrap-select.css";
import "bootstrap-datepicker/dist/css/bootstrap-datepicker3.css";
import "photoswipe/dist/default-skin/default-skin.css";

import './styles/main.scss';

import 'htmx.org';
window.htmx = require('htmx.org');

import morph from '@alpinejs/morph';
import Alpine from 'alpinejs';
import collapse from '@alpinejs/collapse';

import './scripts/shariff.complete.js';
import './scripts/photoswipe.js';
import './scripts/oscar.ui.js';
import './scripts/web.js';
